"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _base = _interopRequireDefault(require("@emotion/styled/base"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _css = _interopRequireDefault(require("@styled-system/css"));

var _Menu = require("reakit/Menu");

var _Button = _interopRequireDefault(require("../../Button/Button"));

var _DropdownContext = require("../DropdownContext/DropdownContext");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  /**
   * Custom caret.
   */
  caret: _propTypes.node,

  /**
   * The content of the toggle.
   */
  children: _propTypes.node,

  /**
   * Override or extend the styles applied to the components.
   */
  classes: (0, _propTypes.shape)({
    root: (0, _propTypes.oneOfType)([(0, _propTypes.shape)({}), _propTypes.func])
  }),

  /**
   * A render prop to change the rendered component.
   * Pass all Reakit props as first param.
   */
  render: _propTypes.func
};
var defaultProps = {
  caret: null,
  children: null,
  classes: {
    root: null
  },
  render: null
};
var Caret = (0, _base["default"])("span", process.env.NODE_ENV === "production" ? {
  target: "e1guy02y0"
} : {
  target: "e1guy02y0",
  label: "Caret"
})((0, _css["default"])({
  display: 'inline-block',
  width: '0',
  height: '0',
  marginLeft: '.255em',
  verticalAlign: '.255em',
  borderTop: '.3em solid currentColor',
  borderRight: '.3em solid transparent',
  borderBottom: '0',
  borderLeft: '.3em solid transparent'
}));
var DropdownToggle = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var caret = _ref.caret,
      _children = _ref.children,
      render = _ref.render,
      props = _objectWithoutProperties(_ref, ["caret", "children", "render"]);

  var menu = (0, _DropdownContext.useDropdown)();
  var renderCaret = caret || /*#__PURE__*/(0, _jsxRuntime.jsx)(Caret, {});
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Menu.MenuButton, _objectSpread(_objectSpread(_objectSpread({
    ref: ref
  }, menu), props), {}, {
    children: function children(toggleProps) {
      return render ? render(toggleProps, renderCaret) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button["default"], _objectSpread(_objectSpread({
        variant: "contained",
        variantColor: "primary",
        endIcon: renderCaret
      }, toggleProps), {}, {
        children: _children
      }));
    }
  }));
});
DropdownToggle.displayName = 'DropdownToggle';
DropdownToggle.propTypes = propTypes;
DropdownToggle.defaultProps = defaultProps;
var _default = DropdownToggle;
exports["default"] = _default;

//# sourceMappingURL=DropdownToggle.js.map